module.exports = __webpack_public_path__ + "static/media/code_by_weight.fb379404.svg";